// extracted by mini-css-extract-plugin
export var heroTopPaddingStyle = "section_centered_hero_wrapper-module--heroTopPaddingStyle--XwhOo";